<template>
  <div class="content">
    <ArtistSelect
      class="artist-selection"
      @memberChangeEvent="getArtistInfo"
      :is-filter="true"
      :include-unit-artist="true"
      :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
      :initial-member-id="$route.query.artistId ? parseInt($route.query.artistId, 10) : null"
    />
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <template slot="header">
          <h4 v-if="memberId" class="card-title" @paste="onSectionPaste">아티스트보드 수정</h4>
        </template>
        <div v-if="memberId" class="row">
          <label class="col-sm-2 col-form-label">보드 이미지</label>

          <div class="col-sm-4">
            <vue-dropzone :options="dropzoneOptions" :useCustomSlot="true" v-on:vdropzone-files-added="onAddFiles" v-on:vdropzone-success="onUploadSuccess">
              <div v-if="!fileId" class="dropzone-custom-content">
                <h3 class="dropzone-custom-title"></h3>
                <div class="subtitle">업로드 할 파일을 드롭하거나 클릭하여 업로드 할 파일을 선택하세요!</div>
              </div>
              <div v-else>
                <img v-bind:src="imageUrl" />
              </div>
            </vue-dropzone>
          </div>
          <label class="col-sm-2 col-form-label">웹 상단 이미지</label>

          <div class="col-sm-4">
            <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="webImageUrl" @onChangeFileIds="onFileIdChange" />
          </div>
        </div>
        <div v-if="memberId" class="row">
          <label class="col-sm-2 col-form-label">본명(그룹명)</label>
          <div class="col-sm-4">
            <base-input placeholder="본명(그룹명)" v-model="realName">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">팬덤</label>
          <div class="col-sm-4">
            <base-input placeholder="팬덤" v-model="fandom">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">데뷔일</label>
          <div class="col-sm-4">
            <base-input placeholder="데뷔일" v-model="debutDate">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">국적</label>
          <div class="col-sm-4">
            <base-input placeholder="국적" v-model="nationality">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">생일</label>
          <div class="col-sm-4">
            <base-input placeholder="생일" v-model="birthDate">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">회사</label>
          <div class="col-sm-4">
            <base-input placeholder="회사" v-model="agencyName">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">구호</label>
          <div class="col-sm-4">
            <base-input placeholder="구호" v-model="slogan">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">멤버</label>
          <div class="col-sm-4">
            <base-input placeholder="멤버" v-model="memberName">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">컬러코드</label>
          <div class="col-sm-4">
            <base-input placeholder="컬러코드" v-model="colorCodes">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">컬러명</label>
          <div class="col-sm-4">
            <base-input placeholder="컬러명" v-model="colorNames">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">그룹명</label>
          <div class="col-sm-4">
            <base-input placeholder="그룹명" v-model="groupName">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">특기</label>
          <div class="col-sm-4">
            <base-input placeholder="특기" v-model="speciality">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">취미</label>
          <div class="col-sm-4">
            <base-input placeholder="취미" v-model="hobby">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">별명</label>
          <div class="col-sm-4">
            <base-input placeholder="별명" v-model="nickname">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">역할</label>
          <div class="col-sm-4">
            <base-input placeholder="역할" v-model="position">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">MBTI</label>
          <div class="col-sm-4">
            <base-input placeholder="MBTI" v-model="mbti">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div v-if="memberId">
          <div class="row">
            <label class="col-sm-12 col-form-label"> SNS 추가 <base-button @click="addSns" type="success">+</base-button></label>
          </div>
          <draggable class="row" v-model="snsList" group="people" @start="drag = true" @end="drag = false">
            <div class="col-sm-12" v-for="(sns, index) in snsList">
              <div class="row">
                <label class="col-sm-2 col-form-label"></label>
                <div class="col-sm-2">
                  <el-select class="select-primary" size="large" placeholder="SNS선택" v-model="sns.type">
                    <el-option v-for="option in snsTypes" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
                  </el-select>
                </div>
                <div class="col-sm-4">
                  <base-input placeholder="주소" v-model="sns.url">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
                <div class="col-sm-2">
                  <base-input placeholder="이름" v-model="sns.name">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
                <base-button @click="removeSns(index)" type="default">-</base-button>
              </div>
            </div>
          </draggable>
        </div>
        <div v-else>
          <div class="row">
            <h4 class="card-title">아티스트보드 업데이트 알림</h4>
          </div>

          <div class="row">
            <label class="col-sm-2 col-form-label">알림 선택</label>
            <div class="col-sm-4">
              <el-select class="select-primary" size="large" placeholder="알림제목" v-model="notification.templateKey">
                <el-option
                  v-for="option in notification.templates"
                  class="select-primary"
                  :value="option.key"
                  :label="option.key"
                  :key="option.key"
                ></el-option>
              </el-select>
            </div>
            <label v-if="notification.hasMember" class="col-sm-2 col-form-label">멤버</label>
            <div v-if="notification.hasMember" class="col-sm-4">
              <el-select class="select-primary" multiple size="large" placeholder="알림멤버" v-model="notification.memberIds">
                <el-option v-for="option in members.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
              </el-select>
            </div>
          </div>
          <div v-if="notification.templateKey.indexOf('UNIT') !== -1" class="row">
            <label class="col-sm-2 col-form-label">유닛 명</label>
            <div class="col-sm-4">
              <base-input placeholder="유닛 명" v-model="notification.groupName">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </div>
          </div>
          <div v-if="notification.templateKey.indexOf('SNS') !== -1" class="row">
            <label class="col-sm-2 col-form-label">SNS 명</label>
            <div class="col-sm-4">
              <base-input placeholder="SNS 명" v-model="notification.sns">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </div>
          </div>
          <div class="row">&nbsp;</div>
          <div class="row">
            <label class="col-sm-2 col-form-label">알림제목</label>
            <div class="col-sm-10">
              <base-input placeholder="알림제목" v-model="notification.title">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </div>
            <label class="col-sm-2 col-form-label">알림문구</label>
            <div class="col-sm-10">
              <base-input placeholder="알림문구" v-model="notification.message">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </div>
            <div class="col-sm-2"></div>
            <div class="col-sm-3">
              <base-button @click="sendNotification()" type="default">알림전송</base-button>
            </div>
          </div>
        </div>
      </card>
      <base-button v-if="memberId != null" native-type="submit" type="success">등록</base-button>
      <base-button @click="copy" v-if="memberId != null">복사</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
    </form>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { Card, BaseInput } from "@/components/index";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { UploadCategory, BlipFileUploader } from "@/util/BlipFileUploader";
import { URLUtils } from "@/util/URLUtils";
import handlebars from "handlebars";
import swal from "sweetalert2";
import draggable from "vuedraggable";
import Endpoints from "@/common/Endpoints";
import BlipFileUploadZone from "@/components/BlipFileUploadZone.vue";

const ARTISTBOARD_LOCATION = {
  SNS: 1,
  ARTIST_COLLECTION: 2,
};

const ARTISTBOARD_NOTIFICATION_TYPE = {
  ARTISTBOARD_UPDATE: 38,
  TRIVIA_UPDATE: 47,
};

export default {
  components: {
    BlipFileUploadZone,
    ArtistSelect,
    Card,
    BaseInput,
    draggable,
    vueDropzone: vue2Dropzone,
  },
  props: {
    maxFiles: { type: Number, default: 1 },
  },
  async created() {
    await this.getSnsList();
  },
  data() {
    return {
      unitId: null,
      unitName: null,
      memberId: null,
      realName: null,
      fandom: null,
      slogan: null,
      debutDate: null,
      memberName: null,
      colorCodes: null,
      colorNames: null,
      nationality: null,
      birthDate: null,
      agencyName: null,
      speciality: null,
      hobby: null,
      mbti: null,
      nickname: null,
      groupName: null,
      position: null,
      fileId: null,
      webFileId: null,
      imageUrl: null,
      webImageUrl: null,
      fileIds: [],
      snsList: [],
      snsTypes: [],
      notification: {
        title: null,
        message: null,
        hasMember: false,
        memberIds: [],
        notificationType: null,
        category: null,
        action: null,
        templateKey: "",
        templates: [
          {
            key: "COMEBACK",
            title: "[{{unitName}}] 프로필 이미지 새단장 완료! 📷",
            message: "매일이 리즈인 {{unitName}}의 정보를 업데이트했어요",
            hasMember: false,
            notificationType: ARTISTBOARD_NOTIFICATION_TYPE.ARTISTBOARD_UPDATE,
          },
          {
            key: "COMEBACK_MEMBER",
            title: "[{{unitName}}] {{memberName}} 프로필 이미지 새단장 완료! 📷",
            message: "매일이 리즈인 {{memberName}}의 정보를 업데이트했어요",
            hasMember: true,
            notificationType: ARTISTBOARD_NOTIFICATION_TYPE.ARTISTBOARD_UPDATE,
          },
          {
            key: "COMEBACK_UNIT",
            title: "[{{unitName}}] {{groupName}} 프로필 이미지 새단장 완료! 📷",
            message: "매일이 리즈인 {{groupName}}의 정보를 업데이트했어요",
            hasMember: true,
            notificationType: ARTISTBOARD_NOTIFICATION_TYPE.ARTISTBOARD_UPDATE,
          },
          {
            key: "NICKNAME",
            title: "[{{unitName}}] 새로운 별명이 추가되었어요 👀",
            message: "지금 바로 확인해보세요",
            hasMember: false,
            notificationType: ARTISTBOARD_NOTIFICATION_TYPE.ARTISTBOARD_UPDATE,
          },
          {
            key: "NICKNAME_MEMBER",
            title: "[{{unitName}}] {{memberName}}의 새로운 별명이 추가되었어요 👀",
            message: "지금 바로 확인해보세요",
            hasMember: true,
            notificationType: ARTISTBOARD_NOTIFICATION_TYPE.ARTISTBOARD_UPDATE,
          },
          {
            key: "SNS",
            title: "[{{unitName}}] 드디어 {{SNS}} 개설!",
            message: "지금 팔로우하고 아티스트 소식을 받아보세요",
            focus: ARTISTBOARD_LOCATION.SNS,
            hasMember: false,
            notificationType: ARTISTBOARD_NOTIFICATION_TYPE.ARTISTBOARD_UPDATE,
          },
          {
            key: "SNS_MEMBER",
            title: "[{{unitName}}] {{memberName}} 드디어 {{SNS}} 개설!",
            message: "지금 팔로우하고 아티스트 소식을 받아보세요",
            focus: ARTISTBOARD_LOCATION.SNS,
            hasMember: true,
            notificationType: ARTISTBOARD_NOTIFICATION_TYPE.ARTISTBOARD_UPDATE,
          },
        ],
      },
      members: {
        options: [],
      },
      uploadMetaLookup: {},
      dropzoneOptions: {
        addRemoveLinks: true,
        method: "post",
        url: (files) => {
          return files.map((file) => {
            return this.uploadMetaLookup[file.upload.uuid].uploadPath;
          });
        },
        accept: async (file, done) => {
          const uploader = new BlipFileUploader();

          const result = await uploader.requestUploadUrl({
            category: UploadCategory.ARTISTBOARD,
            mimeType: file.type,
            fileName: file.name,
            width: file.width,
            height: file.height,
            fileSize: file.size,
          });

          this.uploadMetaLookup[file.upload.uuid] = result;
          this.fileIds.push(result.fileId);
          done();
        },
        sending: async (file, xhr, formData) => {
          const postFields = this.uploadMetaLookup[file.upload.uuid].fields;
          for (let [key, value] of Object.entries(postFields)) {
            formData.append(key, value);
          }
        },
        maxFiles: this.maxFiles,
      },
    };
  },
  watch: {
    notification: {
      handler() {
        const templates = this.notification.templates;
        const template = templates.filter((t) => t.key === this.notification.templateKey)[0];
        const titleTemplate = handlebars.compile(template.title, { noEscape: true });
        const messageTemplate = handlebars.compile(template.message, { noEscape: true });
        const memberName = this.notification.memberIds.map((memberId) => {
          return this.members.options.filter((member) => member.value === memberId)[0].label;
        });
        this.notification.hasMember = template.hasMember;
        this.notification.title = titleTemplate({ unitName: this.unitName, memberName, SNS: this.notification.sns, groupName: this.notification.groupName });
        this.notification.message = messageTemplate({
          unitName: this.unitName,
          memberName,
          SNS: this.notification.sns,
          groupName: this.notification.groupName,
        });
        this.notification.focus = template.focus;
        this.notification.notificationType = template.notificationType;
        this.notification.category = template.category;
        this.notification.action = template.action;
      },
      deep: true,
    },
  },
  methods: {
    onFileIdChange(newFileIds) {
      this.webFileId = newFileIds[0];
    },
    addSns() {
      this.snsList.push({});
    },
    removeSns(index) {
      this.snsList.splice(index, 1);
    },
    async getSnsList() {
      return this.$axios.get("/artistBoard/snsList").then((res) => {
        this.snsTypes = res.data.data.map((list) => {
          return { label: list.name, value: list.id };
        });
      });
    },
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      this.memberId = param.memberId;
      this.unitName = param.unitName;
      await this.getData();
      await this.getArtistMembers();
    },
    async getArtistMembers() {
      return this.$axios.get(`/artistUnit/${this.unitId}/members`, null).then((res) => {
        this.members.options = [];
        const data = res.data.data;
        if (data.length > 0) {
          data.forEach((item) => {
            const option = {};
            option.label = item.blipName;
            option.value = item.artistId;
            if (item.isVisible === 1) {
              this.members.options.push(option);
            }
          });
        }
      });
    },
    async getData() {
      const queryParams = {
        unitId: this.unitId,
        artistId: this.memberId || undefined,
      };
      const path = `/artistBoard/artistBoard?${URLUtils.objectToQueryString(queryParams)}`;
      if (this.$route.fullPath !== path) {
        try {
          await this.$router.push(path);
        } catch (ex) {}
      }
      return this.$axios
        .get("/artistBoard", {
          params: { unitId: this.unitId, memberId: this.memberId },
        })
        .then((res) => {
          this.fileId = null;
          this.imageUrl = null;
          this.nationality = null;
          this.birthDate = null;
          this.agencyName = null;
          this.speciality = null;
          this.hobby = null;
          this.nickname = null;
          this.position = null;
          this.mbti = null;
          this.groupName = null;
          this.realName = null;
          this.fandom = null;
          this.slogan = null;
          this.debutDate = null;
          this.memberName = null;
          this.colorCodes = null;
          this.colorNames = null;
          this.snsList = [];
          const data = res.data.data;
          if (data) {
            this.nationality = data.nationality;
            this.birthDate = data.birthDate;
            this.agencyName = data.agencyName;
            this.speciality = data.speciality;
            this.hobby = data.hobby;
            this.nickname = data.nickname;
            this.groupName = data.groupName;
            this.position = data.position;
            this.mbti = data.mbti;
            this.realName = data.realName;
            this.fandom = data.fandom;
            this.slogan = data.slogan;
            this.debutDate = data.debutDate;
            this.memberName = data.memberName;
            this.colorCodes = data.colorCodes;
            this.colorNames = data.colorNames;
            this.snsList = data.snsList;
            this.fileId = data.fileId;
            this.webFileId = data.webFileId;
            if (this.fileId) {
              this.imageUrl = window.Endpoints.imageServerUrl + this.fileId;
            }
            if (this.webFileId) {
              this.webImageUrl = window.Endpoints.imageServerUrl + this.webFileId;
            }
          }
        });
    },

    async onUploadSuccess(file) {
      const uploader = new BlipFileUploader();
      await uploader.markFileAsUploaded(this.uploadMetaLookup[file.upload.uuid].fileId);
    },
    async onAddFiles() {
      this.uploadMeta = [];
      this.uploadMetaLookup = {};
    },
    getFileIds() {
      return this.fileIds;
    },

    async onSubmit() {
      if (!this.unitId) {
        Toast.error("잘못된 접근입니다.");
        return;
      }
      if (this.snsList) {
        for (const sns of this.snsList) {
          if (!sns) {
            Toast.error("sns를 입력해주세요");
            return;
          } else if (!sns.type) {
            Toast.error("sns 타입을 입력해주세요");
            return;
          } else if (!sns.url) {
            Toast.error("sns url을 입력해주세요");
            return;
          }
        }
      }
      if (this.colorCodes && !this.colorCodes.includes("#")) {
        Toast.error("정확한 컬러코드를 입력해주세요");
        return;
      }
      if (this.colorCodes || this.colorNames) {
        if (this.colorCodes?.split(",").length !== this.colorNames?.split(",").length) {
          Toast.error("컬러코드와 컬러명의 개수가 다릅니다");
          return;
        }
      }
      const param = {
        nickname: this.nickname,
        position: this.position,
        groupName: this.groupName,
        agencyName: this.agencyName,
        speciality: this.speciality,
        hobby: this.hobby,
        mbti: this.mbti,
        unitId: this.unitId,
        memberId: this.memberId,
        nationality: this.nationality,
        realName: this.realName,
        fandom: this.fandom,
        slogan: this.slogan,
        debutDate: this.debutDate,
        birthDate: this.birthDate,
        memberName: this.memberName,
        colorCodes: this.colorCodes,
        colorNames: this.colorNames,
        snsList: this.snsList,
        webFileId: this.webFileId,
      };
      const fileIds = this.getFileIds();
      if (fileIds.length > 0) {
        param.fileId = fileIds[0];
      } else {
        param.fileId = this.fileId;
      }
      return this.$axios
        .post("/artistBoard", {
          params: param,
        })
        .then((res) => {
          Toast.success("등록되었습니다");
          this.getData();
        });
    },
    async sendNotification() {
      swal
        .fire({
          title: "알림 전송 확인",
          text: `알림을 전송하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "전송",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            if (this.notification.templateKey.indexOf("MEMBER") === -1 && this.notification.templateKey.indexOf("UNIT") === -1) {
              this.notification.memberIds = [];
            }
            try {
              return this.$axios
                .put(`/artistBoard/${this.unitId}/notification`, {
                  params: this.notification,
                })
                .then((res) => {
                  Toast.success("전송완료");
                });
            } catch (err) {
              Toast.error("알림 전송 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    goBack() {
      history.go(-1);
    },
    copy() {
      const copiedData = { ...this.$data };
      const dom = document.createElement("textarea");
      document.body.appendChild(dom);
      dom.value = JSON.stringify(copiedData);
      dom.select();
      document.execCommand("copy");
      document.body.removeChild(dom);
      window.Toast.success("클립보드에 복사되었습니다");
    },
    onSectionPaste(e) {
      // Stop data actually being pasted into div
      e.stopPropagation();
      e.preventDefault();

      const memberId = this.memberId;
      const pastedData = e.clipboardData.getData("text");
      try {
        const data = JSON.parse(pastedData);
        console.log(data);
        Object.entries(data).forEach(([key, value]) => {
          this[key] = value;
        });
        this.memberId = memberId;
      } catch (e) {
        window.Toast.error("잘못된 데이터입니다");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.artist-selection {
  margin-bottom: 20px;
}
.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}
.dropzone {
  padding: 0px;
}
.dz-image {
  height: 80% !important;
}
.dz-message {
  margin: 0em !important;
}

.subtitle {
  font-size: 13px;
  color: #314b5f;
}
</style>

<style>
.el-scrollbar .el-select-dropdown__wrap {
  max-height: 1000px;
}
</style>
